export { default } from './change-languages'
